/*** RouteTracker.jsx
 * Tracks previous route across navigation
*/

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Save the current path as "prevPath" before navigation
        const currentPath = location.pathname;
        const lastPath = sessionStorage.getItem("currentPath");

        if (lastPath) {
            sessionStorage.setItem("prevPath", lastPath);
        }

        sessionStorage.setItem("currentPath", currentPath);
    }, [location]);

    return null; // this component does not render anything
};

export default RouteTracker;